export const viewers = {
  csv: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/csv_viewer.vue?vue3'),
  download: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/download_viewer.vue?vue3'),
  image: () => import('./image_viewer.vue'),
  video: () => import('./video_viewer.vue'),
  empty: () => import('./empty_viewer.vue'),
  text: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/source_viewer/source_viewer.vue?vue3'),
  pdf: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/pdf_viewer.vue?vue3'),
  lfs: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/lfs_viewer.vue?vue3'),
  audio: () => import('./audio_viewer.vue'),
  svg: () => import('./image_viewer.vue'),
  sketch: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/sketch_viewer.vue?vue3'),
  notebook: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/notebook_viewer.vue?vue3'),
  openapi: () => import('./openapi_viewer.vue'),
  geo_json: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/geo_json/geo_json_viewer.vue?vue3'),
  too_large: () => import('/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_viewers/too_large_viewer.vue?vue3'),
};

export const loadViewer = (type, isUsingLfs, isTooLarge) => {
  let viewer = viewers[type];

  if (isTooLarge) {
    viewer = viewers.too_large;
  } else if (!viewer && isUsingLfs) {
    viewer = viewers.lfs;
  }

  return viewer;
};
